import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Badge } from "@launchmetrics/lm-ui";
import VoiceDetails from 'components/LM/Voice/Details';
import VoiceRelations from 'components/LM/Voice/Relations';
import VoiceLockButton from "components/LM/Voice/VoiceLockButton";
import VoiceDropdownButton from "components/LM/Voice/VoiceDropdownButton";
import Breadcrumb from "components/LM/common/Breadcrumb";
import Drawer from "components/LM/common/Drawer";
import { Tooltip } from "@launchmetrics/lm-ui";
import { InfoCircleOutline } from '@launchmetrics/lm-icons';

import 'components/LM/Voice/Voice.scss';
import VoiceMergeSuggestion from "components/LM/Voice/Merge/VoiceMergeSuggestion";

const STATUS_MAP = {
	active: { label: "Active", bg: "#16A34A" },
	inactive: { label: "Inactive", bg: "#EC4C47" },
	candidate: { label: "Candidate", bg: "#F59E0B" },
};

function Voice(props) {

	const detailsRef = useRef();
	const mergeSuggestions = props.mergeSuggestions ?? [];
	const crawling = props.crawling ?? [];
	const fetchVoice = props.fetchVoice;

	const [voice, setVoice] = useState(props.voice);
	const [editMode, setEditMode] = useState(props.editable ?? voice.meta.editable);
	const [drawerOpen, setDrawerOpen] = React.useState(false);

	useEffect(() => {
		setVoice(props.voice);
	}, [props.voice]);

	const onSave = () => {
		detailsRef.current.saveChanges(setVoice).then(() => {
			fetchVoice();
		});
	}

	const onCancel = () => {
		detailsRef.current.discardChanges();
	}

	const onOpenDrawer = () => {
		setDrawerOpen(!drawerOpen);
	}

	const onTakeOrReleaseLock = () => {
		setEditMode(true);
	};

	return (
		<>
			<Drawer show={drawerOpen} title={`Merge: ${props.voice.name}`}>
				<VoiceMergeSuggestion onClose={onOpenDrawer} currentVoice={props.voice} suggestedVoices={mergeSuggestions} />
			</Drawer>
			<Container id={`voice_${voice.id}`} key={voice.id} fluid className="p-0 voice">
				<Row>
					<Col md="6" xl="6" className="voice-header align-text-bottom">
						<Breadcrumb items={[
							<span className="d-flex align-items-center">
								{voice.name}
								<Badge
									label={STATUS_MAP[voice.status]?.label}
									className="ml-3 mr-1"
									styleProps={{
										background: STATUS_MAP[voice.status]?.bg,
										color: "#FFF",
									}}
								/>
								<Tooltip content="Status is updated once per day" placement="right">
									<InfoCircleOutline cursor="pointer" />
								</Tooltip>
							</span>
						]} />
					</Col>
					{editMode && (
						<Col md="6" xl="6" className="voice-edition text-right">
							<VoiceLockButton
								key={`voice_lock_${voice.id}`}
								voice_id={voice.id}
								lock={voice.meta.lock}
								onTake={onTakeOrReleaseLock}
								onRelease={onTakeOrReleaseLock}
							/>
							<Button
								key="btnMergeSuggestions"
								className="btn btn-sm ml-2 custom-gray-border"
								variant="outline-dark"
								disabled={!mergeSuggestions.length}
								onClick={onOpenDrawer}>
								Similar Voices: <span className="font-weight-bold">{mergeSuggestions.length}</span>
							</Button>
							<VoiceDropdownButton voice={voice} />
						</Col>
					)}
				</Row>
				<Row>
					<Col md="5" lg="5" xl="3">
						<VoiceDetails
							ref={detailsRef}
							voice={voice}
							className="details"
							editMode={editMode}
							onSave={onSave}
							onCancel={onCancel}
						/>
					</Col>
					<Col md="7" lg="7" xl="9">
						<VoiceRelations
							voiceId={voice.id}
							voiceName={voice.name}
							voiceType={voice.type}
							profiles={voice.socialmedia}
							medias={voice.medias}
							urls={voice.urls}
							crawling={crawling}
							editMode={editMode}
							onSourcesChanged={fetchVoice}
						/>
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default Voice;
